// extracted by mini-css-extract-plugin
export default {"productCarousel":"l0-z"};